import { StackView, Spinner, Button, Text, Icon } from '@planningcenter/tapestry-react';
import React, { useState } from 'react';
import 'stream-chat-react';
import '@planningcenter/datetime-fmt';
import '../../../_virtual/moment.js';
import { useChat } from '../../hooks/use_chat.js';
import '../../chat_api_context.js';
import '@planningcenter/url';
import '@planningcenter/jolt-client';
import 'stream-chat';
import { ErrorCard } from '../ui/error_card.js';
import { Subheading } from '../ui/subheading.js';
import { useMyGroups } from './hooks/use_my_groups.js';

const GroupsShortcuts = ({ isActive }) => {
    const { isLoading, isError, groups } = useMyGroups(isActive);
    const { navigation, setFilterValues } = useChat();
    const [showAll, setShowAll] = useState(false);
    const filteredGroups = groups
        .filter((group) => group.canCreateConversation)
        .sort((a, b) => a.name.localeCompare(b.name));
    const MAX_VISIBLE_GROUPS = 5;
    const visibleGroups = filteredGroups.slice(0, showAll ? undefined : MAX_VISIBLE_GROUPS);
    const hasGroupsWithoutChatPermission = groups.length !== filteredGroups.length;
    const displayGroupsWithoutChatPermissionDisclaimer = hasGroupsWithoutChatPermission &&
        (showAll || filteredGroups.length <= MAX_VISIBLE_GROUPS);
    return (React.createElement(StackView, null,
        React.createElement(StackView, { axis: "horizontal", padding: 2, paddingBottom: 1, alignment: "center", spacing: 1 },
            React.createElement(Subheading, null, "My groups"),
            isLoading && React.createElement(Spinner, { size: "xs" })),
        groups.length === 0 && !isError ? (React.createElement(BlankState, null)) : (React.createElement(StackView, { spacing: 1.5 },
            React.createElement(StackView, null, visibleGroups.map(({ id, name, headerImage: { thumbnail }, membershipsCount, }) => (React.createElement(Button, { alignment: "start", "aria-label": `Select ${name}`, axis: "vertical", borderBottomColor: "separatorTertiary", borderBottomStyle: "solid", borderBottomWidth: 1, hover: { backgroundColor: "surfaceSecondary" }, key: id, paddingHorizontal: 2, paddingVertical: 1, spacing: 0.25, textAlign: "left", theme: false, onClick: () => {
                    setFilterValues({
                        appName: "Groups",
                        values: {
                            group: { id, name },
                        },
                    });
                    navigation.switchToNewGroupsChatView();
                } },
                React.createElement(StackView, { axis: "horizontal", spacing: 1 },
                    React.createElement("img", { alt: "", src: thumbnail, style: {
                            borderRadius: "4px",
                            height: 40,
                            objectFit: "cover",
                            width: 75,
                        } }),
                    React.createElement(StackView, { distribution: "start", maxWidth: "250px" },
                        React.createElement(Text, { lineHeight: "1.3", weight: 500, truncate: true }, name),
                        React.createElement(Text, { lineHeight: "1.3", weight: 300 },
                            membershipsCount,
                            " ",
                            membershipsCount === 1 ? "member" : "members"))))))),
            displayGroupsWithoutChatPermissionDisclaimer && (React.createElement(HasGroupsWithoutChatPermission, null)),
            filteredGroups.length > MAX_VISIBLE_GROUPS && (React.createElement(ToggleGroups, { showAll: showAll, onClick: () => setShowAll(!showAll) })),
            isError && (React.createElement(ErrorCard, { marginHorizontal: 2, message: "There was an issue loading your groups, please refresh and try again." }))))));
};
const BlankState = () => (React.createElement(StackView, { axis: "vertical", alignment: "center", distribution: "center", height: 20, padding: 2 },
    React.createElement(Text, { align: "center", color: "foregroundSecondary" }, "Join a group with chat enabled and permissions to start a new conversation.")));
const HasGroupsWithoutChatPermission = () => (React.createElement(StackView, { alignment: "center", distribution: "center", paddingHorizontal: 2 },
    React.createElement(Text, { lineHeight: "1.3", size: 5 }, "*You have additional groups without chat enabled or permissions to start a new conversation.")));
const ToggleGroups = ({ onClick, showAll, }) => (React.createElement(Button, { variant: "outline", size: "sm", onClick: onClick, marginLeft: "auto", marginRight: "auto", marginBottom: 2 },
    React.createElement(Icon, { name: showAll ? "general.upCaret" : "general.downCaret", size: "lg", paddingRight: 1 }),
    React.createElement(Text, null,
        "View ",
        showAll ? "fewer" : "more",
        " groups")));

export { GroupsShortcuts };
//# sourceMappingURL=groups_shortcuts.js.map
